import { render } from "./NuevoTicketView.vue?vue&type=template&id=ca182aa0"
import script from "./NuevoTicketView.vue?vue&type=script&lang=js"
export * from "./NuevoTicketView.vue?vue&type=script&lang=js"

import "./NuevoTicketView.vue?vue&type=style&index=0&id=ca182aa0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__